import { VStack } from "@gluestack-ui/themed";
import { IdentifyProposalAccordionProps } from "./types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";
import { StatusBadge } from "@repo/core/constants/proposals";
import { Text } from "@repo/core/components/core/Text";
import { ProposalCardStatusEnum } from "@repo/core/enums/proposals";
import { Badge } from "@repo/core/components/core/Badge";

export const IdentifyProposalAccordion = ({
  number,
  status = ProposalCardStatusEnum.APROVED,
  date,
  typist,
  analyst,
  score,
  servicePoint,
  ...rest
}: IdentifyProposalAccordionProps) => {
  return (
    <AccordionContainer {...rest}>
      <InfoSection title="Proposta" value={number} />
      <VStack flex={1}>
        <VStack gap="$2">
          <Text fontSize="$xs" color="$textLight700" fontWeight={500}>
            Status da proposta
          </Text>
          <Badge
            type={StatusBadge[status].type}
            text={StatusBadge[status].text}
          />
        </VStack>
      </VStack>
      <InfoSection title="Data da Proposta" value={date} />
      <InfoSection title="Digitador" value={typist} />
      <InfoSection title="Analista" value={analyst} />
      <InfoSection title="Score" value={score} />
      <InfoSection title="Ponto de Atendimento" value={servicePoint} />
    </AccordionContainer>
  );
};
